/** Generic office photo — same image as the original Offizz home asset cards. */
export const ASSET_OFFICE_PLACEHOLDER_SRC =
  'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=600&h=400&q=80';
